'use client';

import { CircularProgress, Fade, Stack, Typography } from '@mui/material';
import useRotatingMessage from './useRotatingMessage';

type Props = {
  messages: string[];
  active: boolean;
};

const LoadingMessage = ({ messages, active }: Props) => {
  const message = useRotatingMessage({ messages, active });

  return (
    <Stack
      spacing={{ xs: 2, md: 3 }}
      role="status"
      aria-live="polite"
      sx={{
        alignItems: 'center',
        maxWidth: { xs: '100%', sm: 420 },
        px: { xs: 2, md: 3 },
        textAlign: 'center',
      }}
    >
      <CircularProgress color="primary" size={40} />
      <Fade key={message} in appear timeout={500}>
        <Typography
          variant="h6"
          component="p"
          sx={{
            color: 'text.primary',
            fontSize: { xs: '1rem', md: '1.25rem' },
            lineHeight: 1.4,
            textWrap: 'balance',
          }}
        >
          {message}
        </Typography>
      </Fade>
    </Stack>
  );
};

export default LoadingMessage;
